import { render, staticRenderFns } from "./TripShareSectionViewOnly.vue?vue&type=template&id=ad4af2d6"
import script from "./TripShareSectionViewOnly.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripShareSectionViewOnly.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports